import { Box, Typography } from "@mui/material";

const VIDEO_FILE_TYPES = new Set([".mp4", "mp4", ".webm", "webm", ".mov", "mov", ".3gp", "3gp", ".ogg", "ogg"]);
const VIDEO_URL_PATTERN = /\.(mp4|webm|ogg|mov|3gp)(\?|$)/i;

export const isVideoMessage = (message) => {
  const category = String(message?.content?.category ?? "").toLowerCase();
  if (category === "video") return true;

  const contentType = String(message?.content?.type ?? "").toLowerCase();
  if (contentType.startsWith("video/") || VIDEO_FILE_TYPES.has(contentType)) {
    return true;
  }

  const fileUrl = message?.content?.file || message?.content?.url || "";
  return VIDEO_URL_PATTERN.test(fileUrl);
};

export const MessageVideo = ({ message, isOwn }) => {
  const videoUrl = message.content?.file || message.content?.url || message.content?.video;
  const videoName = message.content?.name || message.content?.filename || "video.mp4";

  if (!videoUrl) return null;

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: isOwn ? "flex-end" : "flex-start",
        gap: 0.75,
      }}
    >
      <Box
        component="video"
        src={videoUrl}
        controls
        preload="metadata"
        sx={{
          display: "block",
          width: "100%",
          maxWidth: 260,
          maxHeight: 180,
          borderRadius: 3,
          border: "1px solid rgba(var(--fx-surface-textrgb, 15, 23, 42), 0.12)",
          backgroundColor: "#111827",
          outline: "none",
        }}
      />

      <Typography
        variant="caption"
        sx={{
          fontSize: "0.75rem",
          color: "inherit",
          textAlign: isOwn ? "right" : "left",
          maxWidth: 260,
          wordBreak: "break-all",
          px: 0.5,
          opacity: 0.7,
        }}
      >
        {videoName}
      </Typography>
    </Box>
  );
};
